import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Apps } from '../enums/enum';
import { Permission, UserPermissions } from '../models/shared.model';
import { ErrorHandlerService } from './error-handler.service';
import { SharedUserApiService } from './shared-user-api.service';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  private permissionsSubject = new BehaviorSubject<any[]>([]);
  public permissions$ = this.permissionsSubject.asObservable();
  permissions: Permission[] = [];
  userRoles: UserPermissions[] = [];
  constructor(
    private sharedUserApiService: SharedUserApiService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  getUserDetailFromStorage() {
    const userDetails = localStorage.getItem('user');
    if (!userDetails) {
      return null;
    }

    try {
      const user = JSON.parse(userDetails);
      const activeWarehouseId = localStorage.getItem('imsSelectedWarehouseId');
      if (activeWarehouseId) {
        user.imsDefaultWarehouseId = Number(activeWarehouseId);
      }
      return user;
    } catch (error) {
      console.error('Error parsing user details from localStorage:', error);
      return null;
    }
  }
  public userPermissions: any[] | null = null;
  public rolesLoaded = false;
  getRolesandPerm(appId: number): Promise<any[]> {
    return new Promise((resolve) => {
      try {
        if (this.rolesLoaded && this.userPermissions) {
          resolve(this.userPermissions);
          return;
        }

        const userData = this.getUserDetailFromStorage();
        if (userData) {
          this.sharedUserApiService.getPermissionsByUserId(userData.userid).subscribe({
            next: (data) => {
              if (data) {
                this.userRoles = data as UserPermissions[];
                const appRoles = this.userRoles?.filter(
                  (role) => role.appId === appId || role.appId === Apps.TPMPortal,
                );
                const userPermissions: Permission[] = [];
                appRoles?.forEach((role) => {
                  userPermissions.push(...role.permissions);
                });

                this.userPermissions = userPermissions;
                this.rolesLoaded = true;

                this.permissionsSubject.next(userPermissions);
                resolve(userPermissions);
              } else {
                resolve([]);
              }
            },
            error: (error) => {
              this.errorHandlerService.handleApiError(error);
              resolve([]);
            },
          });
        } else {
          resolve([]);
        }
      } catch (error) {
        console.error('Error in getRolesandPerm:', error);
        resolve([]);
      }
    });
  }
}
